import TextField from './Form/TextField'
import MobileNumber from './MobileNumber'

export const Fields = {
  Input: TextField,
  MobileNumber: MobileNumber,
}



// WEBPACK FOOTER //
// ./src/components/components.js